module.exports = __webpack_public_path__ + "img/404.82b9c7a5.jpg";